var _style, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValencene(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#D86030;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.2,150.9v39.8h10.3v7.6h-10.3v48.3h-10.1V142.4h23.4v8.5H208.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.4,218.4h-9.1l-2.5,28.2h-8.6l9.5-104.2h12.8l10.1,104.2H250L247.4,218.4z M238.9,210.8h7.7l-3.6-40.4 h-0.4L238.9,210.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.3,184.4c0,3.2-0.5,5.5-1.5,7.1c-1,1.5-2.2,2.6-3.7,3.1c1.5,0.4,2.7,1.4,3.7,2.9s1.5,3.9,1.5,7.1v24.3 c0,6.3,0.2,10.7,0.6,13.2s0.7,4,1,4.5h-10.1c-0.7-1.2-1.1-3.2-1.3-6c-0.2-2.8-0.3-6.7-0.3-11.8v-23.4c0-4.8-1.2-7.2-3.6-7.2h-5.4 v48.3h-10.1V142.4H286c3.6,0,6.7,1.2,9.3,3.7c2.6,2.4,3.9,6,3.9,10.8v27.5H299.3z M285.6,190.8c2.4,0,3.6-2.3,3.6-7v-25.5 c0-2.6-0.4-4.5-1.2-5.7c-0.8-1.2-1.8-1.8-3-1.8h-4.8v39.9L285.6,190.8L285.6,190.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 250,
    cy: 196.3,
    r: 98.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.9,141.5h8.8L222,245.6h-12.8l-10-104.2h9.7l6.9,76.1h0.3L222.9,141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.5,217.4h-9.1l-2.5,28.2h-8.6l9.5-104.2h12.8l10.1,104.2H258L255.5,217.4z M247,209.8h7.7l-3.6-40.4h-0.4 L247,209.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.3,141.5V238h12.5v7.6h-22.6V141.5H288.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114,353.7h7l8,23.4h0.1l8-23.4h6.9l-12.1,32.7h-5.7L114,353.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154,353.7h6.3l12.1,32.7h-6.8l-2.3-6.5h-12.5l-2.2,6.5h-6.8L154,353.7z M161.6,374.4l-4.4-12.8h-0.1 l-4.4,12.8H161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.1,353.7h6.6v26.9h14.4v5.8h-21V353.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.4,353.7h20.9v5.8h-14.5v7.9h11.6v5.7h-11.6v7.6h15.5v5.8h-21.9V353.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.3,353.7h6.3l14.7,22h0.1v-22h6.4v32.7h-6.5l-14.5-21.6h-0.1v21.6h-6.4L231.3,353.7L231.3,353.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.1,370.2c0-9.3,6-16.8,16.6-16.8c4.7,0,9.5,2,13,6.3l-4.8,4c-2.1-2.6-4.9-4.1-8.2-4.1 c-5.6,0-9.8,4.1-9.8,10.7c0,6.1,4,10.4,9.9,10.4c3.4,0,6.3-1.7,8.2-4.1l4.7,4.1c-2.8,3.5-7.2,6.2-13,6.2 C272.6,386.7,265.1,380.9,265.1,370.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300,353.7h20.9v5.8h-14.5v7.9H318v5.7h-11.6v7.6h15.5v5.8H300V353.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.9,353.7h6.3l14.7,22h0.1v-22h6.4v32.7H349l-14.5-21.6h-0.1v21.6H328v-32.7H327.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363,353.7h20.9v5.8h-14.5v7.9H381v5.7h-11.6v7.6h15.5v5.8H363V353.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValencene);
export default __webpack_public_path__ + "static/media/Valencene.ccf60240424f87b6d86cf236922717f2.svg";
export { ForwardRef as ReactComponent };